import { ThemeColor } from '@/enums'
import { Typography } from '../Typography'
import { Container } from './styles'

export interface TextBadgeProps {
  backgroundColor?: ThemeColor
  bgOpacity?: number
  text: string
  textColor?: ThemeColor
  size?: 'sm' | 'md'
}

export const TextBadge = ({
  backgroundColor = ThemeColor.b40,
  bgOpacity = 1,
  text,
  textColor = ThemeColor.b0,
  size = 'sm',
}: TextBadgeProps) => (
  <Container
    backgroundColor={backgroundColor}
    bgOpacity={bgOpacity}
    size={size}
  >
    <Typography bold color={textColor || ThemeColor.b0} variant="badgeText">
      {text}
    </Typography>
  </Container>
)
